import { asPlaybookId } from "@repo/app-types/entities/playbook";
import { TeammateRoleTypes } from "@repo/app-types/entities/teammatePermissions";
import { type FC, useEffect } from "react";
import { Outlet, useNavigate, useParams } from "react-router";
import { appPaths } from "../app/appPaths.js";
import { PlaybookHasResultFilterDefault } from "../features/filters/playbookHasResultFilterDefault.js";
import { selectTeammate } from "../features/teammate/teammateSlice.js";
import { useAppSelector } from "../hooks/hook.js";

export const TrainingTeamPage: FC = () => {
  const navigate = useNavigate();

  const { playbookId } = useParams();
  if (!playbookId) {
    throw new Error("Missing playbookId param.");
  }

  const currentTeammate = useAppSelector(selectTeammate);

  // Redirect team members (non admins) to their own page since they don't have permission to view the team page.
  // We may replace this with a dedicated teammate-specific view in the future.
  useEffect(() => {
    if (
      currentTeammate?.permissions.role.type === TeammateRoleTypes.TEAM_MEMBER
    ) {
      navigate(
        appPaths.teammate.build({
          playbookId,
          teammateId: currentTeammate.id,
        }),
        {
          replace: true,
        },
      );
    }
  }, [playbookId, currentTeammate, navigate]);

  return (
    <div className="relative flex h-full flex-col overflow-y-auto">
      <PlaybookHasResultFilterDefault playbookId={asPlaybookId(playbookId)}>
        <Outlet key={playbookId} />
      </PlaybookHasResultFilterDefault>
    </div>
  );
};

// Playbook and teammate tabs are defined in features/teammatePerformance
